import React, { ReactNode } from "react";
import classNames from "classnames";
import Checkbox from "@mui/material/Checkbox";
import ListItem from "@mui/material/ListItem";
import { ChipList, SmallChip } from "common/DS/Chip";
import { Body2, Subtitle1 } from "common/DS/Text";
import COLOR from "lib/colors";
import { blur } from "lib/util";

type Props = {
    content?: ReactNode;
    secondary: ReactNode;
    trailingIcon?: ReactNode;
    tags?: {
        label: React.ReactNode;
        red?: boolean;
        green?: boolean;
        tooltip?: ReactNode | string[];
    }[];
    selectable?: boolean;
    selected?: boolean;
    onSelect?: () => void;
    meta?: ReactNode;
    className?: string;
    grow?: boolean;
};
const ThreeLineListItem = ({
    content,
    secondary,
    trailingIcon,
    tags = [],
    selectable,
    selected,
    onSelect,
    meta,
    className,
    grow,
    ...props
}: Props) => (
    <ListItem
        className={classNames("ws-three-line-list-item flex", {
            "ws-three-line-list-item__selectable": selectable,
            "ws-three-line-list-item__selected": selected,
        })}
        onClick={selectable ? blur(onSelect) : undefined}
        {...props}
    >
        <div className={classNames("flex flex-row flex-afs", { "flex-grow": grow })}>
            {selectable && <Checkbox style={{ fill: COLOR.indigo }} checked={selected} />}
            <div className={classNames(className, { "mt-sm": selectable })}>
                <div className="ws-three-line-list-item__content">
                    <div className="flex flex-row flex-afs flex-jsb gap-sm">
                        {content && (
                            <Subtitle1 style={{ color: COLOR["navy-high"] }}>{content}</Subtitle1>
                        )}
                        <div className="ws-three-line-list-item__meta-container">
                            {meta && <div className="ws-three-line-list-item__meta">{meta}</div>}
                            {trailingIcon}
                        </div>
                    </div>
                </div>
                <div className="flex flex-col">
                    <Body2 style={{ color: COLOR["navy-medium"] }}>{secondary}</Body2>
                    <div className="flex flex-ac mt-xs">
                        <ChipList>
                            {tags && tags.map((t, i) => <SmallChip key={i} {...t} />)}
                        </ChipList>
                    </div>
                </div>
            </div>
        </div>
    </ListItem>
);

export default ThreeLineListItem;
